"use client";
import {
  TooltipContextProvider
} from "../__chunks/RV6RYOXG.js";
import "../__chunks/ZPKRQJBS.js";
import "../__chunks/URSEQETI.js";
import "../__chunks/J7UNXP2A.js";
import "../__chunks/SJ5YBTFK.js";
import "../__chunks/YIF72NQG.js";
import {
  useTooltipStore
} from "../__chunks/QESPTHDX.js";
import "../__chunks/IOEKCBMU.js";
import "../__chunks/GO53B7AR.js";
import "../__chunks/X5ETRS5D.js";
import "../__chunks/5UDX7WKK.js";
import "../__chunks/DTNGDFNU.js";
import "../__chunks/OPTPHWV7.js";
import "../__chunks/4ROCFRIN.js";
import "../__chunks/4R3V3JGP.js";

// src/tooltip/tooltip-provider.tsx
import { jsx } from "react/jsx-runtime";
function TooltipProvider(props = {}) {
  const store = useTooltipStore(props);
  return /* @__PURE__ */ jsx(TooltipContextProvider, { value: store, children: props.children });
}
export {
  TooltipProvider
};
